import React from 'react';
import { Link } from 'react-router-dom';
import services from '../data/services';
import { TechnicalIcon } from './Icons';

function ServiceCards() {
  return <div className="service-grid">{services.map((s, i) => <Link className="service-card" to={'/services#' + s.icon} key={s.title}><div className="card-top"><span className="mono">0{i + 1} /</span><TechnicalIcon type={s.icon} /></div><h3>{s.title}</h3><div className="service-tags">{s.tags.map(t => <span key={t}>{t}</span>)}</div></Link>)}</div>;
}

export default ServiceCards;
